<template>
    <div class="app-container pull-auto">
        <div>
            <div>
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="企业名称" class="el_s_left" >
                        <el-input placeholder="请输入企业名称" v-model="form.condition"></el-input>
                    </el-form-item>
                    <el-form-item label="企业状态" class="el_s_left">
                        <el-select v-model="form.state" placeholder="请选择企业状态" clearable>
                            <el-option label="待审核" value="1"></el-option>
                            <el-option label="未实名" value="0"></el-option>
                            <el-option label="已实名" value="2"></el-option>
                            <el-option label="已冻结" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="el_s_left">
                        <el-button type="primary" icon="el-icon-search" @click="onSubmit">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="el_btn">
                <el-button  :disabled = "totalStatus" @click="examine"   icon="el-icon-view" class="filter-item filter-item1" style="background-color: rgb(230, 162, 59);color:#fff">查看内容
                </el-button>
                <el-button  :disabled = "totalStatus" @click="userSee2"  icon="el-icon-edit-outline" class="filter-item filter-item1" style="background-color: #48CC54; color:#fff">工程详情
                </el-button>
                <el-button  @click="userSee" :disabled = "totalStatus" class="filter-item filter-item1" style="background-color: rgb(230, 162, 000);color:#fff" icon="el-icon-view" >投诉人信息
                </el-button>
            </div>
        </div>
        <el-table :key='tableKey'
                :data="tableData"
                v-loading="listLoading"
                element-loading-text="数据加载中......"
                border fit
                highlight-current-row
                style="width: 99%"
                ref="singleTable"
                @row-click = "showRow"
                @current-change="handleRowClick" >
            <el-table-column align="center" width="30px" type="index" label=" " class="part" >
                <template slot-scope="scope">
                    <el-radio class="radio" v-model="radio"  :label="scope.row.id" >&nbsp;</el-radio>
                </template>
            </el-table-column>

            <el-table-column align="center" width="60px" type="index" label="序号" class="part" >
                <template slot-scope="scope">
                    <span>{{ getSerialNumber(scope.$index)}} </span>
                </template>
             </el-table-column>

            <el-table-column align="center" label="投诉类型">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.typeCode}}
                    </span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="投诉内容" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.content}} </span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                    <span> {{scope.row.state | statusFilter}} </span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="投诉时间">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.createTime /1000 | dateY}}
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <div v-show="!listLoading" class="crud-pagination pull-right">
            <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="listQuery.current"
                       :page-sizes="[10,20,30,50]"
                       :page-size="listQuery.page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
            </el-pagination>
        </div>
              <!-- 查看弹窗 -->
      <el-dialog title="投诉信息" :visible.sync="dialogFormVisible" >
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">


          <el-form-item label="投诉类型" prop="phone" class="el-form-items">
            <el-input v-model="form.typeCode"></el-input>
          </el-form-item>

          <el-form-item label="投诉时间" prop="name" class="el-form-items">
            <el-input v-model="form.createTime"></el-input>
          </el-form-item>

          <el-form-item label="投诉人" prop="name" class="el-form-items">
            <el-input v-model="form.userName"></el-input>
          </el-form-item>

          <el-form-item label="投诉内容" prop="roleIds" class="el-form-items">
            <el-input v-model="form.content"></el-input>
          </el-form-item>

            <el-form-item label="反馈信息" prop="roleIds" class="el-form-items">
                <el-card class="box-card">
                    <div v-for="o in otherData" :key="o.id" class="text item">
                        {{o.createTime/1000 |dateY}}&nbsp;&nbsp;{{o.content }}
                    </div>
                </el-card>
            </el-form-item>

          <el-form-item label="" prop="roleIds" class="el-form-items">
            <el-input v-model="form.otherData"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" class="filter-item filter-item1"  @click="addOther">确 定</el-button>
          <el-button @click="dialogFormVisible = false" class="filter-item filter-item1" size="mini" type="primary" icon="el-icon-circle-check-outline"  :disabled = "totalStatus">关闭</el-button>
        </div>
      </el-dialog>
        <!-- 投诉人信息弹框 -->
        <el-dialog
          title="员工信息"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
              <el-row :gutter="20" class="info_box">
                  <el-col :span="12">
                      <div class="lf">
                          <div>
                              <span>自定义头像:</span>
                              <img :src="comWorkerContent.avatar" alt="" width=100 height=150>
                          </div>
                          <div>
                              <span>员工账号:</span>
                              <span>{{comWorkerContent.avatar}}</span>
                          </div>
                          <div>
                              <span>手机号码:</span>
                              <span>{{comWorkerContent.phone}}</span>
                          </div>
                          <div>
                              <span>状态:</span>
                              <span>{{comWorkerContent.avatar}}</span>
                          </div>
                          <div>
                              <span>创建时间:</span>
                              <span>{{comWorkerContent.createtime/1000 | dateY}}</span>
                          </div>
                          <div>
                              <span>公众号open id:</span>
                              <span>{{comWorkerContent.openId}}</span>
                          </div>
                          <div>
                              <span>Fas服务open id:</span>
                              <span>{{comWorkerContent.openId1}}</span>
                          </div>
                      </div>
                  </el-col>
                    <el-col :span="12">
                      <div class="lf">
                          <div>
                              <span>微信头像:</span>
                              <img :src="comWorkerContent.avatar" alt="" width=100 height=150>
                          </div>
                          <div>
                              <span>员工姓名:</span>
                              <span>{{comWorkerContent.userName}}</span>
                          </div>
                          <div>
                              <span>所属部门:</span>
                              <span>{{comWorkerContent.avatar}}</span>
                          </div>
                          <div>
                              <span>微信昵称:</span>
                              <span>{{comWorkerContent.nickname}}</span>
                          </div>
                          <div>
                              <span>最后登录时间:</span>
                              <span>{{comWorkerContent.lastLoginTime/1000 | dateY}}</span>
                          </div>
                          <div>
                              <span>师傅端open id:</span>
                              <span>{{comWorkerContent.openId2}}</span>
                          </div>
                          <div>
                              <span>union id:</span>
                              <span>{{comWorkerContent.unionId}}</span>
                          </div>
                      </div>
                  </el-col>
              </el-row>
              <span slot="footer" class="dialog-footer">

                  <el-button type="primary" v-if="comStart" @click="handleStop1">冻结</el-button>
                  <el-button type="primary" v-if="comStop" @click="handleStart1">解冻</el-button>
                  <el-button @click="dialogVisible = false">关闭</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
// 查看工人信息
    import {fetchList,selectState,getCompanyInfo,getWorkerInfo,getObj,getObj1,addObj} from '@/api/admin/complaints'
    import {tableOption} from '@/const/asset/base/manufacturerinfo'
    import {mapGetters} from 'vuex'
    import { objKeySort } from '@/util/ajaxsign'
    import { dateY } from '@/util/date'
    export default {
        name: 'manufacturerinfo',
        data() {
            return {
                list: [],
                total: 0,
                // listLoading: true,
                listQuery: {
                    current: 1,
                    size: 10
                },
                //
                otherData:'',
                stopTrue:{},
                stopFalse:{},
                imgUrl:'',
                dialogStop:false,
                dialogStart:false,
                items:'',
                radio:'',
                dialogFormVisible:false,
                dialogVisible:false,
                comWorkerContent:'',
                comStop:false,
                // 状态
                companyId :'',
                // 搜索
                 form: {
                    condition: '',
                    state:''
                 },
                tableData: [],
                page: {
                    total: 0, // 总页数
                    currentPage: 1, // 当前页数
                    pageSize: 20 // 每页显示多少条
                },
                tableLoading: false,
                tableOption: tableOption
            }
        },
        created() {
            this.getList()
        },
        mounted: function () {
        },
        computed: {
            ...mapGetters(['permissions'])
        },
        filters: {
            statusFilter(status) {
                const statusMap = {
                    0: '未认证',
                    1: '审核中',
                    2: '审核通过',
                    3: '拒绝审核',
                    4: '冻结'
                }
                if(status > 4 || status ==4){
                    return statusMap[4]
                }else{
                    return statusMap[status]
                }

            },
            // 日期过滤器
            dateY
        },
        methods: {
            getSerialNumber(index) {
                return index + 1 + (this.listQuery.current - 1) * this.listQuery.size
            },
            // 认证通过
            pass(){
                selectState(objKeySort({companyId:this.companyId,status:2,tips:'认证通过'})).then(response =>{
                    location.reload()
                })
                this.dialogFormVisible = false
            },
            // 认证不通过
            notPass(){
                selectState(objKeySort({companyId:this.companyId,status:3,tips:'认证不通过'})).then(response =>{
                    location.reload()
                })
                this.dialogFormVisible = false
            },
            //  企业师傅信息
            userInfo(){
                //存储企业员工id
                sessionStorage.setItem('companyId',this.companyId)
                this.$router.push({ path: `/companyWorker/index` })
            },
            selectionChange(list){
                console.log(row)
                //  this.$message.success('选中的数据'+ JSON.stringify(list));
            },
            handleStop1(){
                console.log(this.cSate)
                if(this.cSate !='4'){
                    this.dialogStop=true
                }
            },
            showRow(row,event){
                this.radio = row.id;
            },
            // 获取当前行数据
            handleRowClick (row) {
                // var el = event.currentTarget;
            //    console.log(row, event, column)
                this.companyId=row.id
                this.cSate=row.state
                this.totalStatus=false
            },
            //  查看
            examine() {
                this.dialogFormVisible = true
                console.log(objKeySort({id:this.companyId}))
                getObj(objKeySort({id:this.companyId})).then(response => {
                // console.log(response.data.data)
                console.log(response.data.data)
                    this.form = response.data.data
                    this.otherData=response.data.otherData
                })
            },
            // 添加反馈信息
            addOther(){
                console.log(this.form)
                this.dialogFormVisible = false
                addObj(objKeySort({content:this.form.otherData,infoId :this.form.id})).then(()=>{

                })


            },
            //   投诉人信息
            userSee(){
                    if(this.comworkerState==1){
                        console.log(1)
                        this.comStop=false
                        this.comStart=true
                    }
                    if(this.comworkerState==2){
                        console.log(1)
                        this.comStop=true
                        this.comStart=false
                    }

                getObj1(objKeySort({userId:this.comworkerId})).then(response =>{
                    // console.log(response)
                    this.comWorkerContent =response.data.data
                    // 显示冻结 解冻按钮

                })
                this.dialogVisible=true
            },
            // 提交搜索
            onSubmit() {
                console.log(this.form)
                this.form.pageNum=this.listQuery.current
                this.form.pageSize = this.listQuery.size
                // console.log(this.form.condition,this.form.state)
                fetchList(objKeySort(this.form)).then(response => {
                    this.tableData = response.data.data.rows
                    // console.log(response.data.data.length)
                    this.total = response.data.data.total
                    this.tableLoading = false
                })
            },
            getList() {
                this.tableLoading = true
                fetchList(objKeySort({
                    pageNum: this.listQuery.current,
                    pageSize: this.listQuery.size
                })).then(response => {
                    this.tableData = response.data.data.rows
                    // console.log(response.data.data.length)
                    this.total = response.data.data.total
                    this.tableLoading = false
                })
            },
            currentChange(val) {
                this.page.currentPage = val
                this.getList()
            },
            sizeChange(val) {
                this.page.pageSize = val
                this.getList()
            },
             handleSizeChange(val) {
                this.listQuery.size = val
                this.getList()
             },
            handleCurrentChange(val) {
                console.log(111)
                this.listQuery.current = val
                this.getList()
            },
            /**
             * 刷新回调
             */
            refreshChange() {
                this.getList()
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-table{
        margin-top:22px;
    }
    .el_s_left{
        float:left
    }
    .el_btn{
        clear:both;
    }
    .filter-item1{
        width: auto;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        border: 0!important;
        margin-left: 0!important;
        margin-right: 22px;
    }
    .sh_tip{
        vertical-align:top;
        display:inline-block
    }
    .lf_item span:first-child{
        display:inline-block;
        width:100px;
        vertical-align:top;
    }
    .el-form-items{
        float: left;
        width: 48%!important;
    }
    .el-form-itemss{
        width: 300px!important;
        height: 40px!important;
        background-attachment: #fff!important;
    }
    .el-form-itemss .el-input{
        outline: none!important;
    }
    .el-f-item{
        width: 100%!important;
    }
    .el-dialog__header{
        margin-bottom: 25px;
    }
    .el-tag{
        border: 0!important;
        color: #666!important;
        background-color: transparent;
        font-size:14px;
    }
    .dialog-footer{
        margin-left: 0!important;
    }
    .filter-item1{
        width: auto;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        border: 0!important;
        margin-left: 0!important;
        margin-right: 22px;
    }
    .is-required{
        
    }
    /*.select_role{
        -height:100px;
    }*/
    .el-dialog__footer{
        -height:120px;
    }
    .p1{
        width:100% !important;
    }
    .part{
        position: relative;
    }
    /*.el-table ::v-deep .el-radio{

    }*/
    .el-table ::v-deep .el-table__row:nth-child(even) {
        background-color: #F6F9FF !important;
    }
    .info_box{
        padding-top:20px;
        height:450px;
    }
      .lf img{
    vertical-align:top;
  }
  .lf>div>span:first-child{
    display:inline-block;
    width:100px;
  }
  .lf>div{
    margin-bottom:8px;
  }

 .el-dialog__footer{
       margin-top: 65px;
 }
  .lf{

     height:300px;
 }

</style>

